import installer from './defaults'

export * from '@hd-front-end/components'
export * from '@hd-front-end/constants'
export * from '@hd-front-end/directives'
export * from '@hd-front-end/hooks'
export * from './make-installer'

export const install = installer.install
export const version = installer.version
export default installer

export { default as dayjs } from 'dayjs'
